import Axios from "axios";

export function sendFax(documentId) {
    return Axios.post(`/api/pdf/fax/${documentId}`);
}
